import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { META_VIEWPORT_OTHER } from '../../../resources/config';
import { setBrowserTitle } from '../../../actions/core.actions';
import { Store } from '@ngrx/store';
import { RootState } from '../../../reducers';

@Component({
  selector: 'app-tokusyouhou',
  templateUrl: './tokusyouhou.component.html',
  styleUrls: ['./tokusyouhou.component.scss']
})
export class TokusyouhouComponent implements OnInit {
  private title = '特定商取引法';

  constructor(private store: Store<RootState>, private meta: Meta) {}

  ngOnInit() {
    this.store.dispatch(setBrowserTitle({ subTitle: this.title }));
    this.meta.updateTag(META_VIEWPORT_OTHER);
  }
}
